<template>
  <div class="etms-router-body">
    <div class="contant-outer-left fl">
      <el-form v-model="form" ref="scanform" label-width="100px" class="etms-router-form">
        <el-form-item label="扫描分类：">
          <el-radio-group v-model="form.scantype" size="mini">
            <el-radio label="到站扫描">到站扫描</el-radio>
            <el-radio label="出站扫描">出站扫描</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="网点：">
          <el-select size="mini" v-model="form.branchid" filterable class="el-width-200">
            <el-option v-for="item in branchs" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="扫件时间：">
          <el-date-picker size="mini" v-model="form.scantime" type="datetime" placeholder="不选默认为当前时间" class="el-width-200"></el-date-picker>
        </el-form-item>
        <el-form-item label="下一站：">
          <el-select size="mini" v-model="form.nextbranchid" filterable class="el-width-200">
            <el-option v-for="item in branchs" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单号：">
          <el-input size="mini" placeholder="请扫描单号" v-model="form.odd" @keyup.enter.native="submit" class="el-width-200"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="contant-outer-right fl">
      <el-table :data="scanlist" class="etms-router-list">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="odd" label="单号" align="center" width="120px"></el-table-column>
        <el-table-column prop="scantype" label="扫描分类" align="center" width="120px"></el-table-column>
        <el-table-column prop="scantime" label="时间" align="center" width="150px"></el-table-column>
        <el-table-column prop="branch" label="网点" align="center" width="200px"></el-table-column>
        <el-table-column prop="nextbranch" label="下一站" align="center" width="200px"></el-table-column>
        <el-table-column prop="content" label="内容"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      branchs: [
        { value: '0', label: '广州中转站' },
        { value: '1', label: '广州白云区中转站' },
        { value: '2', label: '广州嘉禾中心' },
        { value: '3', label: '清远中转站' },
        { value: '4', label: '清远清城区中转站' },
        { value: '5', label: '清远龙塘镇' },
      ],
      form: {
        scantype: '到站扫描',
        branchid: '',
        nextbranchid: '',
        odd: '',
        scantime: '',
        content: ''
      },
      scanlist: []
    }
  },
  methods: {
    submit () {
      var branch = this.branchs.filter(item => item.value === this.form.branchid)[0]
      var nextbranch = this.branchs.filter(item => item.value === this.form.nextbranchid)[0]

      this.scanlist.push({
        scantype: this.form.scantype,
        branchid: branch.value,
        branch: branch.label,
        nextbranchid: nextbranch !== null && nextbranch !== undefined ? nextbranch.value : '',
        nextbranch: nextbranch !== null && nextbranch !== undefined ? nextbranch.label : '',
        odd: this.form.odd,
        scantime: this.form.scantime !== null && this.form.scantime !== undefined && this.form.scantime !== '' ? this.form.scantime.toLocaleString() : new Date().toLocaleString(),
        content: this.form.scantype === '到站扫描' ? branch.label + ' 已收入' : branch.label + ' 已发出,下一站 ' + nextbranch.label
      })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/branch_scan.vue